import _axios from '../../apiClient'

export function getSucursales(payload) {
  return _axios
    .get(`/api/sucursal/GetSucursalesInstalacion`, {
      params: { ...payload },
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    })
    .then((response) => response.data)
    .catch((error) => {
      const data = error.response.data
      throw data
    })
}

export function getSucursalById(idSucursal) {
  return _axios
    .get(`/api/sucursal/GetSucursalById`, {
      params: { idSucursal },
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    })
    .then((response) => response.data)
    .catch((error) => {
      const data = error.response.data
      throw data
    })
}

export function borrarSucursal(payload) {
  return _axios
    .post(`/api/sucursal/BorrarSucursal`, payload, {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    })
    .then((response) => response.data)
    .catch((error) => {
      const data = error.response.data
      throw data
    })
}

export function activarSucursal(payload) {
  return _axios
    .post(`/api/sucursal/ActivarSucursal`, payload, {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    })
    .then((response) => response.data)
    .catch((error) => {
      const data = error.response.data
      throw data
    })
}

export function saveSucursal(payload) {
  return _axios
    .post(`/api/sucursal/SaveSucursal`, payload, {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    })
    .then((response) => response.data)
    .catch((error) => {
      const data = error.response.data
      throw data
    })
}

export function actualizarSucursal(payload) {
  return _axios
    .post(`/api/sucursal/ActualizarSucursal`, payload, {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    })
    .then((response) => response.data)
    .catch((error) => {
      const data = error.response.data
      throw data
    })
}
